function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 75 86"
}, props), React.createElement("path", {
  d: "M21.68 46.794c-4.761-5.037-7.428-8.705-9.39-11.867-2.744-4.427-2.806-9.679-.279-14.197l8.254-14.736M53.48 52.777l19.946 20.988-15.627 10.919-17.658-18.527",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M54.787 6l8.253 14.736c2.527 4.511 2.458 9.77-.278 14.197-2.148 3.466-5.618 8.036-11.213 13.769L17.25 84.692 1.625 73.771 37.143 36.4c13.834-14.269 17.443-23.006 18.1-27.739.37-2.661-1.685-5.122-4.784-5.745-2.674-.539-6.538-1.064-11.453-1.064h-2.96c-4.915 0-8.78.525-11.453 1.064-3.099.623-5.155 3.084-4.784 5.745.619 4.434 3.107 11.6 14.87 24.311",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M31.532 62.005L16.44 77.843l-6.844-4.782L20.948 61.12c3.181.575 6.758.946 10.584.886z",
  fill: "#F5F5F5",
  stroke: "#5FB9D7",
  strokeWidth: "2"
}), React.createElement("path", {
  d: "M51.538 18.248s-7.481-1.025-14.02-1.025c-6.537 0-14.018 1.025-14.018 1.025",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
})));